// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"text-block_wrapper__iF4Et"};